import React from 'react';
import { HStack, Text, Image } from '@gluestack-ui/themed';
import { useTranslation } from 'react-i18next';
import { useTenantSettingsStore } from '../../../context/TenantSettingsStore';

/**
 * Header component for the left side of the admin panel navigation.
 * Displays the tenant logo and names.
 */
const AdminHeaderLeft: React.FC = () => {
  const { t } = useTranslation();
  const settings = useTenantSettingsStore((state) => state.settings);
  const navbarIconUrl = settings?.imageAssetUrls?.navbarIconUrl;
  const displayName = settings?.naming?.displayName;

  return (
    <HStack alignItems="center" ml="$4">
      {!!navbarIconUrl && (
        <Image
          source={{ uri: navbarIconUrl }}
          w={28}
          h={28}
          mr="$3"
          alt="Tenant Logo"
          resizeMode="contain"
        />
      )}
      <Text size="sm" fontWeight="$semibold" color="$textHeading">
        {t('admin.navigation.title')}
      </Text>
      {!!displayName && (
        <Text size="xs" color="$textSubtle" ml="$3">
          {displayName}
        </Text>
      )}
    </HStack>
  );
};

export default AdminHeaderLeft;
